import { createContext, useState, ReactNode } from "react";
import { viabilityUnlock, trackBandView } from "~src/api/brands";
import { logError } from "~src/utils/logger";
type TrendViabilityLockContextType = {
  loading: boolean;
  viewViabilityReport: boolean;
  handleUnlockViability: (brandId: number) => void;
};

enum ViabilityReportViewType {
  brandView = 0,
  reportView = 1,
}

const ViabilityLockContext =
  createContext<TrendViabilityLockContextType | null>(null);

const ViabilityLockProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false);
  const [viewViabilityReport, setViewViabilityReport] = useState(false);

  const triggerBrandTracking = async (brandId: number) => {
    const viewType = ViabilityReportViewType.reportView;
    await trackBandView(brandId, viewType);
  };

  const handleUnlockViability = async (brandId: number) => {
    if (brandId) {
      setLoading(true);
      try {
        await viabilityUnlock(brandId);
        setViewViabilityReport(true);
        triggerBrandTracking(brandId);
      } catch (err) {
        logError(`Error: ${err}`);
      } finally {
        setLoading(false);
      }
    }
  };

  const contextValue = {
    loading,
    viewViabilityReport,
    handleUnlockViability,
  };

  return (
    <ViabilityLockContext.Provider value={contextValue}>
      {children}
    </ViabilityLockContext.Provider>
  );
};

export { ViabilityLockContext, ViabilityLockProvider };
